module.exports = __webpack_public_path__ + "img/25.3ca6b067.gif";